import { some, flatMap } from 'lodash';

const newQueryFormFields = {
  computed: {
    /**
     * The shared fields.
     *
     * @returns {Array}
     */
    sharedFields() {
      const allSharedFields = flatMap(this.form.consultations.length > 0 ? this.form.consultations : this.template.endpoints, (consultations) => consultations.fields || [])
        .filter((field) => !field.name.includes('/'));

      return allSharedFields
        .reduce((sharedFields, field) => {
          if (!some(sharedFields, ['name', field.name])) {
            sharedFields.push({ ...field });
          }

          return sharedFields;
        }, [])
        .map((field) => {
          const equalFields = allSharedFields.filter(({ name }) => name === field.name);

          const hasSomeWithNoRule = equalFields.some((equalField) => !equalField.oneOf || equalField.oneOf.length === 0);
          const everyIsOptional = equalFields.every((equalField) => !!equalField.optional);

          return {
            ...field,
            oneOf: hasSomeWithNoRule ? undefined : flatMap(equalFields, 'oneOf'),
            optional: everyIsOptional,
          };
        });
    },

    /**
     * The exclusives fields grouped.
     *
     * @returns {Array}
     */
    exclusiveFieldsGrouped() {
      if (this.form.consultations.length > 0) {
        return this.form.consultations.reduce((groups, consultation) => {
          if (!consultation.fields) {
            return groups;
          }

          const exclusiveFields = consultation
            .fields
            .filter(({ name }) => name.includes('/'));

          if (exclusiveFields.length === 0) {
            return groups;
          }

          groups.push({
            name: consultation.name,
            label: consultation.label,
            fields: exclusiveFields,
          });

          return groups;
        }, []);
      }

      return this.template.consultations.reduce((groups, consultation) => {
        const endpoint = this.template.endpoints.filter((e) => e.name === consultation.name)[0];

        if (!endpoint.fields) {
          return groups;
        }

        const exclusiveFields = endpoint
          .fields
          .filter(({ name }) => name.includes('/'));

        if (exclusiveFields.length === 0) {
          return groups;
        }

        groups.push({
          name: `${consultation.name}#${consultation.id}`,
          label: endpoint.label,
          id: consultation.id,
          fields: exclusiveFields,
        });

        return groups;
      }, []);
    },
  },
};

export default newQueryFormFields;
